//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";

//services

//components
import paymentMethodManager from "emun.payments/payment-method-manager";
// import states from "emun.payments/payments.states";

export const dependencies = [
  "as.sortable",
  "bootstrapLightbox",
  collapse,
  dropdown,
  "emun.activity",
  "emun.auth",
  "emun.cart",
  "emun.customer",
  "emun.invoice",
  "emun.markdown",
  "emun.offer",
  "emun.order",
  "emun.products",
  "emun.promotion",
  "emun.prospect",
  "emun.retailer",
  "emun.salesrep",
  "emun.shopping",
  "emun.swatch",
  "emun.vendor",
  "moment-picker",
  "servicestack",
  tabs,
  "ui.bootstrap",
  "ui.router",
  "views",
  "webforms",
  "webmodals",
  "webutils",
];

export const config = {
  html5Mode: ($locationProvider) => {
    console.debug("Configuring $locationProvider to use HTML5 mode");
    $locationProvider.html5Mode(true);
  },
};

export const runners = {
  html5Mode: () => {
    console.debug("runners HTML5 mode");
  },
};

export const modules = {
  // modals,
};

export const states = {};
export const services = {};

export const components = {
  paymentMethodManager,
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states,
  runners,
  config,
};
